export default class VColumn<T extends { _id: string }> {
  public field;
  public displayName;
  public visible = true;
  public sortable = false;
  public defaultSort = false;
  public defaultSortDirection = 'asc';
  public visibleOnHover = false;
  public style: { [key: string]: string } | null = null;
  public align = 'left';
  public formatter;
  public enumMap;
  public className;
  public sortField: string | null = null;
  public resizable = true;
  public width;
  public calculatedWidth = 0;
  public calculatedResizable = true;
  public dataKey: string;

  constructor(params: {
    field: string;
    displayName: string;
    visible?: boolean;
    sortable?: boolean;
    defaultSort?: boolean;
    defaultSortDirection?: string;
    visibleOnHover?: boolean;
    style?: { [key: string]: string };
    align?: string;
    formatter?: (value: string, row: T, column: VColumn<T>) => React.ReactNode;
    enumMap?: Map<string, string>;
    className?: string;
    sortField?: string;
    resizable?: boolean;
    width?: number;
  }) {
    if (params.field) this.field = params.field;
    if (params.displayName) this.displayName = params.displayName;
    if (params.visible !== undefined) this.visible = params.visible;
    if (params.sortable !== undefined) this.sortable = params.sortable;
    if (params.defaultSort !== undefined) this.defaultSort = params.defaultSort;
    if (params.defaultSortDirection) this.defaultSortDirection = params.defaultSortDirection;
    if (params.visibleOnHover !== undefined) this.visibleOnHover = params.visibleOnHover;
    if (params.style) this.style = params.style;
    if (params.align) this.align = params.align;
    if (params.formatter) this.formatter = params.formatter;
    if (params.enumMap) this.enumMap = params.enumMap;
    if (params.className) this.className = params.className;
    if (params.sortField) this.sortField = params.sortField;
    if (params.resizable !== undefined) this.resizable = params.resizable;
    if (params.width) this.width = params.width;
    this.dataKey = `${this.field}::${this.displayName}`;
  }

  render(value: string, row: T): React.ReactNode {
    if (this.formatter && typeof this.formatter === 'function') {
      return this.formatter(value, row, this);
    }
    return value;
  }
}
